<template>
    <div>
        <!-- 大格子容器 -->
        <div id="big-grid-container">
            <!-- 动态生成的 9 个 grid-container -->
            <div v-for="(gridContainer, index) in gridContainers" :key="index" class="grid-container">
                <!-- 每个 grid-container 中的 9 个 grid-item -->
                <div v-for="(image, imgIndex) in gridContainer" :key="imgIndex" class="grid-item"
                    :style="{ backgroundColor: image.backgroundColor }">
                    <!-- 透明 overlay，用于触发放大效果 -->
                    <div class="overlay" @click="openLightbox(image.src)"></div>
                    <img :src="image.src" :alt="'图片 ' + image.index" />
                </div>
            </div>
        </div>

        <!-- Lightbox 容器 -->
        <div v-show="isLightboxOpen" class="lightbox" @click="closeLightbox">
            <img :src="lightboxImageSrc" alt="点击查看大图" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imageList: [],
            isLightboxOpen: false,
            lightboxImageSrc: "",
            gridContainers: [],
        };
    },
    mounted() {
        // 使用 require 来引入图片路径并生成 imageList
        this.imageList = Array.from({ length: 81 }, (_, i) => require(`@/assets/images/pic${i + 1}.jpg`));
        this.generateGridContainers();
    },
    methods: {
        // 生成9个grid-container，每个container包含9个grid-item
        generateGridContainers() {
            const gridContainers = [];
            let currentImageIndex = 0;
            if (this.imageList.length === 0) {
                console.error('图片列表为空!');
                return;
            }

            for (let i = 0; i < 9; i++) {
                const gridContainer = [];
                for (let j = 0; j < 9; j++) {
                    if (currentImageIndex < this.imageList.length) {
                        gridContainer.push({
                            src: this.imageList[currentImageIndex],
                            index: currentImageIndex + 1,
                            backgroundColor: this.getRandomColor(),
                        });
                        currentImageIndex++;
                    }
                }
                gridContainers.push(gridContainer);
            }

            this.gridContainers = gridContainers;
        },
        getRandomColor() {
            const r = Math.floor(Math.random() * 256);
            const g = Math.floor(Math.random() * 256);
            const b = Math.floor(Math.random() * 256);
            return `rgb(${r}, ${g}, ${b})`;
        },
        // 打开 Lightbox 显示大图
        openLightbox(imageSrc) {
            this.lightboxImageSrc = imageSrc;
            this.isLightboxOpen = true;
        },
        // 关闭 Lightbox
        closeLightbox() {
            this.isLightboxOpen = false;
        },
    },
};
</script>

<style scoped>
/* 页面基础样式 */
body {
    font-family: Arial, sans-serif;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /* 3列，宽度相等 */
    grid-template-rows: repeat(3, 1fr);
    /* 3行，高度相等 */
    width: 100%;
    height: 100%;
    margin: 10px auto;
}

.grid-item {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease;
    /* 设置过渡动画 */
}

/* 悬停时整个 grid-item 包括 overlay 和图片都会放大 */
.grid-item:hover {
    transform: scale(1.1);
    /* 放大整个格子 */
}

.grid-item img {
    width: 70%;
    height: 100%;
    object-fit: cover;
}

/* overlay 样式 */
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    z-index: 999;
    cursor: pointer;
}



/* 大格子容器样式 */
#big-grid-container {
    padding-top: 10vw;
    /* 设置顶部间距 */
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    width: 100%;
    height: 100%;
}

/* Lightbox 容器 */
.lightbox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.935);
    justify-content: center;
    align-items: center;
    z-index: 9999;
    display: flex;
}

.lightbox img {
    max-width: 90%;
    max-height: 90%;
}
</style>
